// src/pages/AlertsPage.tsx — Fraud Alerts (real data)
import React, { useState, useEffect, useCallback } from 'react';
import { getAlerts, resolveAlert } from '../services/api';
import type { AlertType, FraudAlert } from '../types';

export function AlertsPage() {
  const [alerts,  setAlerts]  = useState<FraudAlert[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    getAlerts({ resolved: 'false', limit: 50 })
      .then(r => setAlerts(r.data.data || []))
      .catch(() => setAlerts([]))   // genuinely no data on error
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const resolve = async (id: string) => {
    try { await resolveAlert(id); } catch {}
    setAlerts(a => a.filter(x => x.id !== id));
  };

  const count = (type: AlertType) => alerts.filter(a => a.type === type).length;
  const fmtTime = (t: string | null | undefined) => t ? new Date(t).toLocaleString('en-IN', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' }) : '—';

  return (
    <>
      <div className="topbar">
        <div className="topbar-title">🚨 Fraud Alerts</div>
        <span style={{ fontSize:12, color:'var(--ink3)' }}>{alerts.length} unresolved</span>
        <button className="btn btn-secondary" style={{ padding:'6px 12px', fontSize:12 }} onClick={load} disabled={loading}>
          {loading ? <span className="spin">⟳</span> : '↻'} Refresh
        </button>
      </div>

      <div className="page-content fade-in">
        <div className="grid-3" style={{ marginBottom:16 }}>
          {[
            { label:'Duplicate Scans',   val: count('DUPLICATE_SCAN'),    color:'var(--red)'  },
            { label:'Location Mismatch', val: count('LOCATION_MISMATCH'), color:'var(--amb)'  },
            { label:'Velocity Breach',   val: count('VELOCITY_BREACH'),   color:'var(--purp)' },
          ].map(s => (
            <div key={s.label} className="card" style={{ textAlign:'center' }}>
              <div style={{ fontSize:28, fontWeight:700, color:s.color }}>{s.val}</div>
              <div style={{ fontSize:11, color:'var(--ink3)' }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          <div className="tbl-scroll">
            <table className="tbl">
              <thead>
                <tr><th>Case</th><th>Bag ID</th><th>Dealer</th><th>Type</th><th>Details</th><th>Severity</th><th>Time</th><th>Action</th></tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={8} style={{ textAlign:'center', padding:32 }}><span className="spin">⟳</span></td></tr>
                ) : alerts.length === 0 ? (
                  <tr><td colSpan={8} style={{ textAlign:'center', padding:32, color:'var(--g2)' }}>✅ No unresolved fraud alerts</td></tr>
                ) : alerts.map(a => (
                  <tr key={a.id}>
                    <td className="mono" style={{ fontSize:10 }}>FRD-{String(a.id).slice(-6)}</td>
                    <td className="mono" style={{ fontSize:11 }}>{a.bag?.bagId || '—'}</td>
                    <td className="mono" style={{ fontSize:11, color:'var(--ink3)' }}>{a.bag?.dealer?.dealerCode || '—'}</td>
                    <td style={{ fontSize:11 }}>{a.type.replace(/_/g,' ')}</td>
                    <td style={{ fontSize:11, color:'var(--ink3)' }}>{a.description}</td>
                    <td><span className={`tag ${a.severity==='HIGH'||a.severity==='CRITICAL'?'tag-red':'tag-amber'}`}>{a.severity}</span></td>
                    <td style={{ fontSize:10, color:'var(--ink3)', whiteSpace:'nowrap' }}>{fmtTime(a.createdAt)}</td>
                    <td><button className="btn btn-danger" style={{ padding:'4px 10px', fontSize:11 }} onClick={() => resolve(a.id)}>Resolve</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
export default AlertsPage;
